import { css } from "styled-system/css";

export const containerStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "lg",
});

export const addBtnStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "sm",
  paddingInline: "sm",
  paddingY: "4px",
  fontSize: "12px",
  fontWeight: "700",
  color: "textBase",
  backgroundColor: "transparent",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  borderRadius: "medium",
  width: "fit-content",
  _hover: {
    backgroundColor: "bgBase200",
  },
});

export const formCardStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "md",
  paddingY: "md",
  paddingInline: "0.125rem",
});

export const formHeaderStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "sm",
  fontSize: "sm",
  fontWeight: "700",
  marginBottom: "xs",
});

export const fieldStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
});

export const labelStyles = css({
  fontSize: "xs",
  fontWeight: "700",
  color: "color-mix(in srgb, {colors.textBase}, transparent 50%)",
});

export const inputStyles = css({
  width: "100%",
  padding: "sm",
  borderRadius: "medium",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "bgBase100",
  color: "inherit",
  outline: "none",
  fontSize: "sm",
  _focus: {
    borderColor: "primary",
  },
});

export const inputErrorStyles = css({
  borderColor: "error",
});

export const rowStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const checkboxGroupStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "sm",
  cursor: "pointer",
});

export const actionGroupStyles = css({
  display: "flex",
  gap: "sm",
});

export const primaryBtnStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "sm",
  paddingInline: "md",
  paddingY: "0.375rem",
  fontSize: "sm",
  fontWeight: "700",
  color: "primaryContent",
  backgroundColor: "primary",
  borderRadius: "medium",
});

export const ghostBtnStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "sm",
  paddingInline: "md",
  paddingY: "0.375rem",
  fontSize: "sm",
  fontWeight: "700",
  color: "textBase",
  backgroundColor: "transparent",
  borderRadius: "medium",
  _hover: {
    backgroundColor: "color-mix(in srgb, {colors.textBase}, transparent 95%)",
  },
});

export const patternCardStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "sm",
  paddingY: "md",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "bgBase300",
  transitionProperty: "opacity",
  transitionDuration: "200ms",
});

export const patternCardEnabledStyles = css({
  opacity: 1,
});

export const patternCardDisabledStyles = css({
  opacity: 0.5,
});

export const codeBlockStyles = css({
  fontSize: "sm",
  fontFamily: "mono",
  backgroundColor: "bgBase200",
  paddingInline: "xs",
  paddingY: "0.125rem",
  borderRadius: "4px",
});

export const cardFooterStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "xs",
  color: "color-mix(in srgb, {colors.textBase}, transparent 40%)",
  marginTop: "xs",
});

export const patternsListStyles = css({
  display: "flex",
  flexDirection: "column",
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: "bgBase300",
});

export const groupHeaderStyles = css({
  fontSize: "14px",
  fontWeight: "700",
  opacity: 0.5,
  marginTop: "lg",
  marginBottom: "xs",
});

export const emptyStateStyles = css({
  textAlign: "center",
  fontSize: "14px",
  opacity: 0.5,
  paddingY: "2rem",
});

export const editGroupStyles = css({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "md",
  paddingInline: "0.125rem",
});
